import React from 'react';
import Image from './Image';
import Description from './Description';

export default function Card(props){
    return(
        <div className="card" id={props.id}>
              <Image className={props.className} src={props.src} alt={props.alt}/>
              <Description className={props.className} header={props.header} paragraph={props.paragraph}/>
        </div>
    )
}